const getQueryVariable = (variable: string, queryParams: string) => {
    var vars = queryParams.split("&");
    for (var i of vars) {
        var pair = i.split("=");
        if (pair[0] == variable) return pair[1];
    }
    return '';
}

export default getQueryVariable;